import React from 'react';

import StreamContext from '@smart-tv/contexts/stream-context';

export const useStream = () => {
  const values = React.useContext(StreamContext);
  const previousStreamTitlesRef = React.useRef(values.streamTitles);

  if (values.streamTitles) {
    previousStreamTitlesRef.current = values.streamTitles;
  }

  return {
    ...values,
    displayStreamTitles: values.streamTitles || previousStreamTitlesRef.current
  };
};

export default useStream;
